import OrderCargoOrderDetailsHandlingLogParams from "../../../../../../common/services/order/cargo-order/handling-log/order-cargo-order-details-handling-log-params";

const create = (
  orderId: string,
  creationEnd?: Date,
  creationStart?: Date,
): OrderCargoOrderDetailsHandlingLogParams => {
  return {
    orderId: orderId,
    creationEnd: creationEnd || undefined,
    creationStart: creationStart || undefined,
  };
};

const orderDetailsHandlingLogLoadParamsFactory = {
  create,
};

export default orderDetailsHandlingLogLoadParamsFactory;
